export default abstract class BaseError<Data = unknown> extends Error {
  constructor(info: {
    name: string
    message: string
    action: string
    stack?: string
    data?: Data
    cause?: unknown
  }) {
    super()

    this.name = info.name
    this.stack = info?.stack
    this.cause = info?.cause

    this.data = info?.data
    this.message = info.message
    this.action = info.action
  }

  action: string
  data?: Data
}
